"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _hooks = require("../../hooks");
var _SubscriptionForm = require("../SubscriptionForm");
var _Translated = _interopRequireDefault(require("../Translated"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(() => (0, _styles.createStyles)({
  subheader: {
    fontSize: 18,
    lineHeight: 1.2
  },
  header: {
    fontWeight: 'bold',
    marginBottom: 10
  }
}));
const SubscriptionFormWrapper = _ref => {
  let {
    children,
    renderHeader,
    ...props
  } = _ref;
  const classes = useStyles();
  const intl = (0, _hooks.useIntl)();
  const renderDefaultHeader = () => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h4",
    className: classes.header,
    component: "h1"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscription_template1_header"
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    paragraph: true,
    variant: "h6",
    className: classes.subheader,
    component: "h4"
  }, /*#__PURE__*/_react.default.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: intl.formatMessage({
        id: 'subscription_template1_subheader'
      }, {
        br: '<br />'
      })
    }
  })));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    textAlign: "center",
    mb: 5
  }, renderHeader ? renderHeader() : renderDefaultHeader()), children, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_SubscriptionForm.SubscriptionForm, props)));
};
var _default = exports.default = SubscriptionFormWrapper;